import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'admin-pages-issue-types-directory.table.empty-state.header',
		defaultMessage: 'No issue types were found that match your search',
		description: 'Empty state message header',
	},
});
